import { render } from "./afterpay-icon.vue?vue&type=template&id=1986969b"
const script = {}

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__